// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".career-content {\n  padding-top: 20px;\n  font-size: 15px;\n  color: #fff;\n}", "",{"version":3,"sources":["webpack://./src/pages/Career/styles.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,eAAA;EACA,WAAA;AACJ","sourcesContent":[".career-content {\n    padding-top: 20px;\n    font-size: 15px;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
